import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { mainurl } from '../../MainUrl';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';
import { Row, Col, Card, CardBody, Spinner, Input, Button, FormGroup, Label } from 'reactstrap';
import { notification } from '../../component/hocs/notification';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const ViewFinished = () => {
  const [tableData, setTableData] = useState([]); // State to hold the table data
  const [loading, setLoading] = useState(false); // Loading state
  const [productNames, setProductNames] = useState([]); // Finished product names for filtering
  const [fromDate, setFromDate] = useState(new Date());  // Default to today's date
    const [toDate, setToDate] = useState(new Date());
  const [selectedProduct, setSelectedProduct] = useState(""); // Selected product name for filtering

  const formatDateForDisplay = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  const formatDateForBackend = (date) => {
    if (!date || isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;  // Correct format for backend
  };

  // Fetch finished product data
  const getListHandler = () => {
    setLoading(true);
    axios
      .get(mainurl + 'view_finished', {
        params: {
          from_date: fromDate,
          to_date: toDate,
          product_name: selectedProduct,
        },
      })
      .then((response) => {
        console.log('API Response:', response.data); // Debugging: Log API response

        const list = response.data.data?.flatMap((row, index) => {
          console.log('Row:', row); // Debugging entire row data

          const details = row?.finished_stock_details;

          // Case 1: If finished_stock_details exists, process it
          if (details && details.length > 0) {
            const sortedDetails = details.sort((a, b) => a.stock_details_id - b.stock_details_id);
            return sortedDetails.map((stock) => ({
              sl: index + 1,
              Finished_Product_Name: row?.finished_product_name ?? 'N/A',
              StockIn_UOM: stock.stock_in
                ? `${stock.stock_in} ${stock.uom_master?.uom ?? 'N/A'}`
                : '0',
              StockOut_UOM: stock.stock_out
                ? `${stock.stock_out} ${stock.uom_master?.uom ?? 'N/A'}`
                : '0',
              Current_Stock_UOM: `${stock.current_stock} ${stock.uom_master?.uom ?? 'N/A'}`,
              Transaction_Date: stock.transaction_date ?? 'N/A',
              reference_number: stock.ref_no ?? 'N/A',
            }));
          }

          // Case 2: If finished_stock_details does not exist, process row directly
          console.warn(`No finished_stock_details for row at index ${index}`);
          return [
            {
              sl: index + 1,
              Finished_Product_Name: row?.finished_product_name ?? 'N/A',
              StockIn_UOM: row.stock_in
                ? `${row.stock_in} ${row.stock_in_uom ?? 'N/A'}`
                : '0',
              StockOut_UOM: row.stock_out
                ? `${row.stock_out} ${row.stock_out_uom ?? 'N/A'}`
                : '0',
              Current_Stock_UOM: `${row.current_stock} ${row.current_stock_uom ?? 'N/A'}`,
              Transaction_Date: row.transaction_date ?? 'N/A',
              reference_number: row.ref_no ?? 'N/A',
            },
          ];
        }) || [];

        setTableData(list);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching finished product data:', error);
        notification('error', 'Failed to fetch finished product data');
        setLoading(false);
      });
  };

  // Fetch finished product names for filter from API (using product_list)
  const fetchProductNames = () => {
    axios
      .get(mainurl + 'product_list') // Fetch product names from product_list endpoint
      .then((response) => {
        setProductNames(response.data.data || []);
      })
      .catch((error) => {
        console.error('Error fetching product names:', error);
        notification('error', 'Failed to fetch product names');
      });
  };

   // Fetch product status data based on filters (only when filters are provided)
   const getFilteredStatusData = () => {
    if (!fromDate || !toDate || !selectedProduct) {
      return; // Skip if filters are not provided
    }
  
    setLoading(true);
  
    // Log the request body before making the request
    const requestBody = {
      from_date: formatDateForBackend(fromDate),
      to_date: formatDateForBackend(toDate),
      finished_product_id: selectedProduct,
    };
    console.log('Request Body:', requestBody);  // Logs the request body
  
    axios
      .post(mainurl + 'product_status', requestBody)  // Send the request
      .then((response) => {
        console.log('API Response:', response.data);
  
        if (!response.data?.success || !response.data?.data) {
          console.error('No data in response');
          notification('error', 'No data available for the given filters');
          setLoading(false);
          return;
        }
  
        // Process the API response
        const list = response.data.data.flatMap((row, index) => {
          // Check if finished_stock_details exists and is an array
          const details = Array.isArray(row.finished_stock_details) ? row.finished_stock_details : [];
  
          if (details.length === 0) {
            console.warn(`No finished_stock_details for row at index ${index}`);
            return []; // Return an empty array if no details
          }
  
          // Sort details by stock_details_id
          const sortedDetails = [...details].sort((a, b) => a.stock_details_id - b.stock_details_id);
  
          return sortedDetails.map((stock) => ({
            sl: index + 1,
            Finished_Product_Name: row.finished_product_name || 'N/A',
            StockIn_UOM: stock.stock_in
              ? `${stock.stock_in} ${stock.stock_in_uom || 'N/A'}` // Use stock_in_uom directly
              : '0',
            StockOut_UOM: stock.stock_out
              ? `${stock.stock_out} ${stock.stock_out_uom || 'N/A'}` // Use stock_out_uom directly
              : '0',
            Current_Stock_UOM: `${stock.current_stock} ${stock.current_stock_uom || 'N/A'}`, // Use current_stock_uom directly
            Transaction_Date: stock.transaction_date
              ? new Date(stock.transaction_date).toISOString().split('T')[0]
              : 'N/A',
            reference_number: stock.ref_no || 'N/A',
          }));
        }) || [];
  
        // Set the table data
        setTableData(list);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching filtered status data:', error);
        notification('error', 'Failed to fetch filtered status data');
        setLoading(false);
      });
  };
  


  // Fetch data on component mount
  useEffect(() => {
    getListHandler();
    fetchProductNames();
  }, [fromDate, toDate, selectedProduct]);

  // Custom DataTable styles
  const customTableStyles = {
    rows: {
      highlightOnHover: true,
      style: {
        textAlign: 'center',
      },
    },
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#FF0000',
        color: 'white',
        textAlign: 'center',
      },
    },
    cells: {
      style: {
        //padding: '10px',
        textAlign: 'center',
      },
    },
  };

  // Custom column styles to add extra gap between columns
  const columnStyles = {
    sl: {
      width: '80px',
      //paddingRight: '100px', // Increased space after "Sl No" for more gap
    },
    Finished_Product_Name: {
      //paddingRight: '250px', // Adjust spacing for Raw Material Name column
    },
    Transaction_Date: {
      //paddingLeft: '80px', // Adjust spacing for Transaction Date column
    },
    reference_number: {
      //paddingRight: '80px', // Adjust spacing for Reference Number column
    },
    StockIn_UOM: {
      //paddingRight: '80px', // Adjust spacing for Stock In column
    },
    StockOut_UOM: {
      //paddingRight: '80px', // Adjust spacing for Stock Out column
    },
    Current_Stock_UOM: {
      //paddingLeft: '80px', // Adjust spacing for Current Stock column
    },
  };

  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          <Col xs={12} className="mb-1">
            <Title pageTitle="Finished Product List" />
          </Col>

          <Col xs={12}>
            <Card color="primary" outline>
              <CardBody>
                {/* Search Filters Section */}
                <FormGroup row>
                                  <Label for="fromDate" sm={2}>From Date</Label>
                                  <Col sm={4}>
                                    <DatePicker
                                      selected={fromDate}
                                      onChange={(date) => setFromDate(date)}
                                      dateFormat="dd/MM/yyyy"
                                      placeholderText="Select From Date"
                                      className="form-control"
                                      isClearable
                                    />
                                  </Col>
                                  
                                  <Label for="toDate" sm={2}>To Date</Label>
                                  <Col sm={4}>
                                    <DatePicker
                                      selected={toDate}
                                      onChange={(date) => setToDate(date)}
                                      dateFormat="dd/MM/yyyy"
                                      placeholderText="Select To Date"
                                      className="form-control"
                                      isClearable
                                    />
                                  </Col>
                                  
                                  
                                </FormGroup>

                <FormGroup row style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <Label for="productName" sm={2}>
                    Product Name
                  </Label>
                  <Col sm={4}>
                    <Input
                      type="select"
                      id="productName"
                      value={selectedProduct}
                      onChange={(e) => setSelectedProduct(e.target.value)}
                    >
                      <option value="">All</option>
                      {productNames.map((product) => (
                        <option key={product.finished_product_id} value ={product.finished_product_id}>
                          {product.finished_product_name} - {product.finished_product_id}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col sm={4}>
                 
<Button color="primary" onClick={getFilteredStatusData}>
  Filter Status
</Button>
                  </Col>
                </FormGroup>

                {/* Table */}
                {loading ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : tableData.length === 0 ? (
                  <div className="text-center text-danger">No finished product data available.</div>
                ) : (
                  <DataTable
                    columns={[
                      {
                        name: 'Sl No',
                        selector: (row) => row.sl,
                        width: '80px',
                        style: { textAlign: 'center' },
                      },
                      {
                        name: 'Finished Product Name',
                        selector: (row) => row.Finished_Product_Name,
                        wrap: true,
                        style: { 
                          textAlign: 'left', 
                          marginRight: '20px',  // Add right margin for space between columns
                        },
                      },
                      {
                        name: 'Transaction Date',
                        selector: (row) => row.Transaction_Date,
                        wrap: true,
                        style: { 
                          textAlign: 'center', 
                          marginLeft: '20px',  // Add left margin for space between columns
                        },
                      },
                      {
                        name: 'Reference Number',
                        selector: (row) => row.reference_number,
                        wrap: true,
                        style: { textAlign: 'center' },
                      },
                      {
                        name: 'Stock In',
                        selector: (row) => row.StockIn_UOM,
                        wrap: true,
                        style: { textAlign: 'center' },
                      },
                      {
                        name: 'Stock Out',
                        selector: (row) => row.StockOut_UOM,
                        wrap: true,
                        style: { textAlign: 'center' },
                      },
                      {
                        name: 'Current Stock',
                        selector: (row) => row.Current_Stock_UOM,
                        wrap: true,
                        style: { textAlign: 'center' },
                      },
                    ]}
                    data={tableData} // Use tableData instead of filterData
                    keyField="sl"
                    pagination
                    paginationPerPage={tableData.length} // Set to the total number of rows
                    paginationRowsPerPageOptions={[5, 10, 20, 50]}
                    customStyles={customTableStyles}
                    conditionalRowStyles={columnStyles} // Apply the custom column styles
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
};

export default ViewFinished;
